import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { configApi } from "@/lib/api";

export function useGenerateConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (module: string) => configApi.generate(module),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["config-status"] });
      qc.invalidateQueries({ queryKey: ["config-drift"] });
    },
  });
}

export function useReloadConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (module: string) => configApi.reload(module),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["config-status"] });
      qc.invalidateQueries({ queryKey: ["config-drift"] });
    },
  });
}

/**
 * Whether the generated .conf files still match the database.
 *
 * A save that never reached Asterisk is otherwise invisible: the database holds
 * the new value and the UI reports success while Asterisk runs the old config.
 */
export function useConfigDrift() {
  return useQuery({
    queryKey: ["config-drift"],
    queryFn: configApi.drift,
    refetchInterval: 30000,
  });
}
